module.exports = __webpack_public_path__ + "img/close.5ed72050.svg";